"use client"

import { Menu02, X as CloseIcon } from "@untitledui/icons"
import type { PropsWithChildren } from "react"
import {
  Button as AriaButton,
  Dialog as AriaDialog,
  DialogTrigger as AriaDialogTrigger,
  Modal as AriaModal,
  ModalOverlay as AriaModalOverlay,
} from "react-aria-components"

import { BrandLockup } from "./brand-lockup"

import { cx } from "@uui/utils/cx"

export const MobileNavigationHeader = ({ children }: PropsWithChildren) => {
  return (
    <AriaDialogTrigger>
      {/* Frosted ink-on-canvas bar — the public light header / /design nav idiom
          in its native horizontal form, so the cream world reaches the top of
          every authed page on mobile. */}
      <header className="border-secondary bg-surface-base/90 sticky top-0 z-30 flex h-16 items-center justify-between border-b py-3 pr-2 pl-4 backdrop-blur-sm lg:hidden">
        <BrandLockup />

        <AriaButton
          aria-label="Expand navigation menu"
          className="group text-fg-secondary outline-focus-ring hover:bg-primary_hover hover:text-fg-secondary_hover flex items-center justify-center rounded-lg p-2 focus-visible:outline-2 focus-visible:outline-offset-2"
        >
          <Menu02 className="size-6 transition duration-200 ease-in-out group-aria-expanded:opacity-0" />
          <CloseIcon className="absolute size-6 opacity-0 transition duration-200 ease-in-out group-aria-expanded:opacity-100" />
        </AriaButton>
      </header>

      <AriaModalOverlay
        isDismissable
        className={({ isEntering, isExiting }) =>
          cx(
            "bg-overlay/70 fixed inset-0 z-50 cursor-pointer pr-16 backdrop-blur-md lg:hidden",
            isEntering && "animate-in fade-in duration-300 ease-in-out",
            isExiting && "animate-out fade-out duration-200 ease-in-out",
          )
        }
      >
        {({ state }) => (
          <>
            <AriaButton
              aria-label="Close navigation menu"
              onPress={() => state.close()}
              className="text-fg-white/70 outline-focus-ring hover:text-fg-white fixed top-3 right-2 flex cursor-pointer items-center justify-center rounded-lg p-2 hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              <CloseIcon className="size-6" />
            </AriaButton>

            <AriaModal className="w-full cursor-auto will-change-transform">
              <AriaDialog className="h-dvh outline-hidden focus:outline-hidden">
                {children}
              </AriaDialog>
            </AriaModal>
          </>
        )}
      </AriaModalOverlay>
    </AriaDialogTrigger>
  )
}
